export const ERROR_RECEIVE = 'ERROR_RECEIVE'
export const GETUSERINFO_REQUEST = 'GETUSERINFO_REQUEST'
export const GETUSERINFO_RECEIVE = 'GETUSERINFO_RECEIVE'
export const GETSERVERLIST_REQUEST = 'GETSERVERLIST_REQUEST'
export const GETSERVERLIST_RECEIVE = 'GETSERVERLIST_RECEIVE'
export const GETGAMEROLELIST_REQUEST = 'GETGAMEROLELIST_REQUEST'
export const GETGAMEROLELIST_RECEIVE = 'GETGAMEROLELIST_RECEIVE'
export const GETAREALIST_REQUEST = 'GETAREALIST_REQUEST'
export const GETAREALIST_RECEIVE = 'GETAREALIST_RECEIVE'
export const GETSWITCHINFO_REQUEST = 'GETSWITCHINFO_REQUEST'
export const GETSWITCHINFO_RECEIVE = 'GETSWITCHINFO_RECEIVE'
export const INIT = 'INIT'